import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpBackend) // carga desde archivos json
  .use(LanguageDetector) // detecta idioma del navegador
  .use(initReactI18next)
  .init({
    fallbackLng: "es",
    debug: false,
    ns: ["common"], // namespaces por defecto
    defaultNS: "common",
    preload: ["es", "en", "pt"],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
